import { debounce } from "lodash";
import { getItemSuggestionApi, getItemsApi,getUnitTypeApi } from "../../utils/ApiEndpointFunctions";
import Spinwheel from "../common/Spinwheel"
import AsyncSelect from 'react-select/async';
import { formatPrice } from "../../utils/HelperFuncitons";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Select from 'react-select';
import { useUserContext } from "../../context/userContext";
// import Autocomplete from "react-autocomplete";


function ItemsAddModal(props) {
  const { formik, addLoader, modalId, type, removeItem, selectItem, vendorId,listType } = props;

  
  
  const location = useLocation()
  const [isAddBtn, setIsAddBtn] = useState(true)
  const [units,setUnits] = useState([])
  const {langPreference} = useUserContext()

  const paths = location.pathname?.split("/")
  const isOther = paths.includes('dpr') ||  paths.includes('boq')
  const isSubcontractor = listType?.toLowerCase() === 'sub-contractor'
  const addItemLabel = isSubcontractor
    ? (langPreference?.add_service || "Add Service")
    : (langPreference?.add_item || "Add Item")


  const filteritems = async (inputValue, cb) => {
    try {
      const res = await ((paths.includes('challan') || paths.includes('dpr')) ? getItemsApi(inputValue, "", "", vendorId) : getItemSuggestionApi(inputValue,"","","",listType))
      if (res.status === 200) {
        const seenItems = new Set()
        const fetchedItems = res.data?.data?.items || []
        let fetchedItem = fetchedItems.filter(ele => {
          const key = [ele?.name, ele?.hsnCode, ele?.type]
            .map(value => String(value || "").trim().replace(/\s+/g, "").toLowerCase())
            .join("|")
          if (seenItems.has(key)) return false
          seenItems.add(key)
          return true
        }).map(ele => ({
            label: ele?.hsnCode ? `${ele.name} (${ele.hsnCode})` : ele.name,
            value: ele
          }))
        cb(fetchedItem);
      }
    } catch (error) {
      console.log(error)
    }
  };

  const itemsOnChange = debounce(filteritems, 1000);

  const itemsOptions = (inputValue, callback) => {
    itemsOnChange(inputValue, callback);
  }

const getUnitType = async()=>{
  try {
    const res = await getUnitTypeApi()
    if(res?.status==200 && res?.data?.data){
      let getUnits = []
      if(listType){
        getUnits = res?.data?.data?.unitTypes?.filter(item=>item?.type?.toLowerCase()==listType?.toLowerCase())?.map(ele => ({ label: ele.name, value: ele?.name }))
      }else{
        getUnits = res?.data?.data?.unitTypes?.map(ele => ({ label: ele.name, value: ele?.name }))
      }
       setUnits([...getUnits,{label: "Other", value: "Other"}])
    }
  } catch (error) {
    console.log("failed to get unit type");
    setUnits([])
  }
}



const handleUnitType =(e)=>{
  // console.log("handleUnitType",e);
  formik.setFieldValue("unitType",e?.value)
}


  const handleItemSelect = (e) => {
    formik.setFieldValue("isDisabled", false)
    if (selectItem) {
      if (e.__isNew__) {
        formik.setFieldValue("name", e.value);
      } else {
        formik.setFieldValue("name", e.value?.name);
      }
    } else {
      if (e.__isNew__) {
        formik.resetForm();
        formik.setFieldValue("isDisabled", false)
        formik.setFieldValue("name", e.value);
        formik.setFieldValue("__isNew__", e.__isNew__);
        //  for add item default value 
        formik.setFieldValue('unitPrice', '')
        formik.setFieldValue('totalQuantity','')
      } else {
        formik.setFieldValue("__isNew__",  false);
        formik.setFieldValue("name", e.value?.name);
        formik.setFieldValue("localName", e.value?.localName);
        formik.setFieldValue("description", e.value?.description || null);
        formik.setFieldValue('hsnCode', e.value?.hsnCode ? e.value?.hsnCode : "")
        //  for add item default value 
        formik.setFieldValue('unitPrice', '')
        formik.setFieldValue('totalQuantity','')
        formik.setFieldValue('unitType', e.value?.unitType || formik.initialValues.unitType)
        formik.setFieldValue('tax', e.value?.tax || formik.initialValues.tax)
        formik.setFieldValue('_id', e.value?._id || null)
      }
    }
    if(isOther){
      formik.setFieldValue("isDisabled", true)
    }
  }


  useEffect(()=>{
    if(!selectItem){
      formik.setFieldValue('unitPrice', '')
      formik.setFieldValue('totalQuantity', '')
    }
    getUnitType()
  },[selectItem,isAddBtn,vendorId,listType])
  return (
    <>
      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog  modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button type="button" id="confirmModalCloseBtn" className="btn-close1" data-bs-dismiss="modal" aria-label="Close"
                onClick={() => setIsAddBtn(true)}
              ><i className="bi bi-x-lg" ></i></button>
            </div>
            <div className="modal-body ">
              <div className="">
                <div className="bb">
                  <h5>{selectItem ? (isOther ? langPreference?.remove || "Remove" : langPreference?.edit_item_service || "Edit") : addItemLabel}</h5>
                </div>
                <form onSubmit={formik?.handleSubmit} className="my-fx">

                  {/* {(type === "challan" || type === "addChallan") ?  */}
                  <label htmlFor="name" >{langPreference?.name || "Name"} <span className='req-error'>*</span></label>
                  <div className="d-flex justify-content-center align-items-center mb-3 ">
                    {isAddBtn ? (
                      <AsyncSelect
                        key={vendorId}
                        className="col"
                        placeholder={langPreference?.select || "Select..."}
                        cacheOptions
                        loadOptions={itemsOptions}
                        defaultOptions
                        value={formik?.values?.name ? { label: formik?.values?.name, value: formik.values } : null}
                        onChange={(e) => { handleItemSelect(e) }}
                        isDisabled={(paths.includes('challan') || paths.includes('dpr')) && selectItem}
                      />

                    ) : (
                      <input
                        className="form-control col"
                        placeholder={langPreference?.write || "Enter..."}
                        value={formik?.values?.name || ''}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="name"
                      />
                    )}
                    <span className=" ms-2" style={{ cursor: "pointer" }} onClick={() => { formik?.resetForm(); formik.setFieldValue("isDisabled", !Boolean(isAddBtn)); setIsAddBtn(value => (!value)) }} >
                      {!selectItem && <span>
                        {paths.includes('purchase') && (isAddBtn ? <>
                          <i className="form-input bi bi-plus-square " /><span>{" "}{addItemLabel}</span>
                        </>
                          :
                          <>
                            <i class="form-input bi bi-x-circle"></i><span>{" "}{langPreference?.cancel || "Cancel"}</span>
                          </>)
                        }
                      </span>}
                    </span>
                  </div>
                  <div className="ed-box">
                    <label htmlFor="localName" >{langPreference?.item_local_name || "Item Local name"} {type!="dpr" && <span className='req-error'>*</span>}</label>
                    <input type="text" disabled={formik.values.isDisabled} className="form-control" id="localName" placeholder={langPreference?.write || "write"} name='localName' value={formik?.values?.localName} onChange={formik?.handleChange} onBlur={formik?.handleBlur} />
                    {formik?.touched?.localName && formik?.errors?.localName ? (<div className='req-error'>{formik?.errors?.localName}</div>) : null}
                  </div>

                  <div className="ed-box">
                    <label htmlFor="description" className="form-label">{langPreference?.description || "Description"} {type!="dpr" && <span className='req-error'>*</span>}</label>
                    <input type="text" disabled={formik.values.isDisabled} className="form-control" id="description" placeholder={langPreference?.write || "write"} name='description' value={formik?.values?.description} onChange={formik?.handleChange} onBlur={formik?.handleBlur} />
                    {formik?.touched?.description && formik?.errors?.description ? (<div className='req-error'>{formik?.errors?.description}</div>) : null}
                  </div>
                  <div className={`row row-cols-2"}`}>
                    <div className="ed-box">
                      <label htmlFor="unitType" className="form-label">{langPreference?.unit || "Unit type"} </label>
                      <Select key={vendorId} style={{ cursor: "pointer !important" }} isDisabled={formik.values.isDisabled} className="w-100" aria-label="Default select example" name='unitType' placeholder="Select unit type" value={{ label: formik?.values?.unitType, value: formik?.values?.unitType }} isSearchable={true} options={units} onChange={(e) => { handleUnitType(e) }} />
                      {formik?.touched?.unitType && formik?.errors?.unitType ? (<div className='req-error'>{formik?.errors?.unitType}</div>) : null}
                    </div>
                   {formik?.values?.unitType?.toLowerCase()=="other" && <div className="ed-box">
                      <label htmlFor="otherUnit" className="form-label">{langPreference?.other_unit_type || "Other unit"}</label>
                      <input
                        className="form-control col"
                        placeholder={langPreference?.write || "Write"}
                        value={formik?.values?.otherUnit || ''}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="otherUnit"
                      />
                      {formik?.touched?.otherUnit && formik?.errors?.otherUnit ? (<div className='req-error'>{formik?.errors?.otherUnit}</div>) : null}
                    </div>} 
                  </div>

                  <div className="ed-box">
                    <label htmlFor="hsnCode" className="form-label">{langPreference?.hsn_code || "HSN code"} </label>
                    <input type="text" disabled={formik.values.isDisabled} className="form-control" id="hsnCode" placeholder={langPreference?.enter_hsn || "HSN code"} name='hsnCode' value={formik?.values?.hsnCode}
                      onChange={(e) => {
                        e.target.value =  e?.target?.value?.toUpperCase()?.replace(/[^a-zA-Z0-9 ]/g, "");
                        formik?.handleChange(e);
                      }}
                      onBlur={formik?.handleBlur} />
                    {formik?.touched?.hsnCode && formik?.errors?.hsnCode ? (<div className='req-error'>{formik?.errors?.hsnCode}</div>) : null}
                  </div>

                  <div className="ed-box">
                    <label htmlFor="tax" className="form-label">{langPreference?.gst || "GST"} (%)</label>
                    <select className="form-select" disabled={formik.values.isDisabled} name='tax' aria-label="Default select example" value={formik?.values?.tax} onChange={formik?.handleChange} onBlur={formik?.handleBlur}  >
                      <option value="0">0</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="12">12</option>
                      <option value="18">18</option>
                      <option value="28">28</option>
                    </select>

                    {formik?.touched?.tax && formik?.errors?.tax ? (<div className='req-error'>{formik?.errors?.tax}</div>) : null}
                  </div>

                  {type === "challan" && <>
                    <div className="mb-3 d-flex justify-content-between">
                      <label htmlFor="tax" className="form-label">{langPreference?.breakage || "Item breakage"}</label>
                      <div className="form-check form-switch">
                        <input className="form-check-input" disabled={formik.values.isDisabled} type="checkbox" role="switch" id="flexSwitchCheckChecked" name="isBreakage" checked={formik.values.isBreakage} onChange={(e) =>{ formik.setFieldValue("isBreakage", e.target.checked); if(!e?.target?.checked){formik.setFieldValue("breakage","")}}} />
                      </div>
                    </div>

                    <div className="mb-3">
                      <textarea className="form-control" id="exampleFormControlTextarea1" disabled={!formik.values.isBreakage} rows="3" value={formik?.values?.breakage} name="breakage" onChange={formik?.handleChange}></textarea>
                    </div>
                  </>}

                  <div className="d-flex mt-4 justify-content-end align-items-center">
                    {
                      ((!selectItem && isOther) || !isOther) &&   <button type="submit" disabled={addLoader} className="save"
                      onClick={() => setIsAddBtn(true)}
                    >
                      {addLoader ? <Spinwheel sizeclassName={"spin-small"} /> : langPreference?.save || "Save"}
                    </button>
                    }
                  

                    {type === "challan" && selectItem && selectItem === formik?.values?._id && <div className="btn btn-secondary ms-3" onClick={() => { removeItem(formik?.values?._id) }}>
                      {langPreference?.remove || "Remove"}
                    </div>}
                    
                    {type === "po" && selectItem &&  selectItem === formik?.values?._id && <div className="btn btn-secondary ms-3" onClick={() => { removeItem(formik?.values?._id) }}>
                    {langPreference?.remove || "Remove"}
                    </div>}

                    {type === "dpr" && selectItem && <div className="btn btn-secondary ms-3" onClick={() => { removeItem(selectItem) }}>
                    {langPreference?.remove || "Remove"}
                    </div>}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ItemsAddModal
